import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@activebrands/core-web/libs/styletron';
import { setProductListLayout } from '@activebrands/core-web/state/productList/actions';

const Button = styled('button', {
    height: '16px',
    width: '16px',
    padding: '1px',
    border: '1px solid var(--color-border)',
    borderRadius: '1px',
});

const Cell = styled('div', {
    height: '100%',
    borderRadius: '1px',
    transition: 'background var(--transition-fast)',
});

const SingleViewButton = () => {
    const dispatch = useDispatch();
    const { layout } = useSelector(state => state.productList);

    return (
        <Button type="button" onClick={() => dispatch(setProductListLayout('single-view'))}>
            <Cell $style={{ background: layout === 'single-view' ? 'var(--color-bg-inverted)' : 'transparent' }} />
        </Button>
    );
};

export default SingleViewButton;
